var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_vm._l((_vm.source),function(image,index){return [(image && image.media)?_c('source',{key:index,attrs:{"srcset":_vm.srcset(image.src),"media":image.media,"type":_vm.type(image.src),"draggable":"false"}}):_vm._e()]}),(_vm.source[0])?_c('img',{class:{
      'image': true,
      'image--cover': _vm.cover,
      'image--contain': _vm.contain
    },attrs:{"loading":"lazy","src":_vm.src,"alt":_vm.source[0].alt,"draggable":"false"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }